exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-push{\n\tposition: absolute;\n\ttop: 49vh;\n\tleft: -26px;\n}\n.button-push:hover,.button-pop-up:hover{\n\tcursor: pointer;\n}\n.image-button{\n\tcolor: black;\n    font-size: 24px;\n}\n", ""]);

// exports
